import React, { useState } from "react";
import { motion } from "framer-motion";
import "../Styles/CabBookingPage.css";
import { useNavigate } from "react-router-dom";

export default function CabBooking() {
  const [tripType, setTripType] = useState("OutStation one way");
  const [pickupTime, setPickupTime] = useState("10:00");
  const navigate = useNavigate();

  const tripOptions = [
    "OutStation one way",
    "OutStation Round Way",
    "Airport Cabs",
    "Rentals",
  ];

  return (
    <div className="cabbooking-container">
      {/* Search Bar */}
      <motion.div
        className="cabbooking-searchbar"
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6 }}
      >
        <select
          className="cabbooking-dropdown"
          value={tripType}
          onChange={(e) => setTripType(e.target.value)}
        >
          {tripOptions.map((opt, i) => (
            <option key={i} value={opt}>
              {opt}
            </option>
          ))}
        </select>

        <button className="cabbooking-addstops">+ Add Stops</button>

        <input
          type="time"
          value={pickupTime}
          onChange={(e) => setPickupTime(e.target.value)}
          className="cabbooking-time"
        />

        <button className="cabbooking-searchbtn">Search</button>
      </motion.div>

      {/* Cab Card */}
      <motion.div
        className="cabbooking-card"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="cabbooking-card-header">
          <h2 className="cabbooking-carname">Indica, Swift</h2>
          <h3 className="cabbooking-price">2,453/-</h3>
        </div>
        <p className="cabbooking-subtitle">4 seats , Ac</p>

        <div className="cabbooking-rating">
          <span>⭐ 3.1</span>
        </div>

        <div className="cabbooking-features">
          <span>✅ Water bottle</span>
          <span>✅ Blankets</span>
          <span>✅ Charging Point</span>
          <span>✅ Reading Light</span>
          <span>✅ Food</span>
        </div>

        <div className="cabbooking-footer">
          <button className="cabbooking-bookbtn" onClick={()=>navigate("/transports-cab-review-page")}>Book a cab</button>
        </div>
      </motion.div>
      <motion.div
        className="cabbooking-card"
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="cabbooking-card-header">
          <h2 className="cabbooking-carname">Indica, Swift</h2>
          <h3 className="cabbooking-price">2,453/-</h3>
        </div>
        <p className="cabbooking-subtitle">4 seats , Ac</p>

        <div className="cabbooking-rating">
          <span>⭐ 3.1</span>
        </div>

        <div className="cabbooking-features">
          <span>✅ Water bottle</span>
          <span>✅ Blankets</span>
          <span>✅ Charging Point</span>
          <span>✅ Reading Light</span>
        </div>

        <div className="cabbooking-footer">
          <button className="cabbooking-bookbtn">Book a cab</button>
        </div>
      </motion.div>
    </div>
  );
}
